'use client'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHiveIconSmallLight } from '@awesome.me/kit-94e593bf23/icons/kit/custom'
import { useHelpWidget } from '@/app/_plugins/HelpWidget'

const HelpButton = () => {
    const { openWidget, closeWidget, isOpen } = useHelpWidget()

    const handleClick = () => {
        if (isOpen) {
            closeWidget()
        } else {
            openWidget()
        }
    }

    return (
        <button
            onClick={handleClick}
            className="flex items-center group"
            aria-label="Open help widget"
        >
            <FontAwesomeIcon
                icon={faHiveIconSmallLight}
                aria-hidden="true"
                className="text-lg text-primary group-hover:text-light mr-0.5 mb-0.25 transition-colors"
            />
            <span className="text-sm text-ink-muted hover:text-primary transition-colors duration-200">Help</span>
        </button>
    )
}

export default HelpButton
